import Vue from "vue";
import { io } from "socket.io-client";

// var socket;

const bodyConnect = {
    transports: ["websocket", "polling"],
    withCredentials: true,
    extraHeaders: {
        "my-custom-header": "abcd",
    },
};

// const header = {
//     userToken: {
//       req: {
//         headers: {
//           authorization:
//             "Bearer " +
//             Vue.prototype.$session.get("accessToken"),
//         },
//       },
//     },
//     message: "message",
//   }

function WSS() {
    var socket;
    this.socket = function() {
        return socket;
    };

    this.connect = function(path) {
        socket = io(Vue.prototype.$wss2 + path, bodyConnect);
        // {
        //   transports: ["websocket", "polling"],
        //   withCredentials: true,
        //   extraHeaders: {
        //     "my-custom-header": "abcd",
        //   },
        //   // auth: {
        //   //   token: Vue.prototype.$session.get("accessToken"),
        //   // }
        // }
        console.log("connect socket", socket);
    };

  this.on = function (path, callback) {
    console.log("socket on ", path);
    socket.on(path, (message) =>{ 
      // console.log('aa');
      callback(message)
    });
  };

    this.emit = function(path, message) {
        let token = Vue.prototype.$session.get("accessToken");
        console.log("emit", socket);
        // console.log(token);
        socket.emit(path, {
            userToken: {
                req: {
                    headers: {
                        authorization: "Bearer " + token,
                    },
                },
            },
            message: message,
        });
    };

    this.disconnect = function() {
        console.log("disconnect");
        socket.disconnect();
    };
}

export default {
    WSS,
};